/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-25T10:30:39.697
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousesales-'

export default 
{
path: '/rentmanage/renthousesales',
name: 'rentmanage-renthousesales',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousesales-index',

meta:{
...meta,
title: '销售人员'
},

component: () => import('@/pages/rentmanage/renthousesales/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousesales-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '销售人员编辑'
},

component: () => import('@/pages/rentmanage/renthousesales/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousesalesdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '销售人员新增'
},

component: () => import('@/pages/rentmanage/renthousesales/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousesalesView',
auth: [
'hidden'
],

meta:{
...meta,
title: '销售人员详情查看'
},

component: () => import('@/pages/rentmanage/renthousesales/detail-view') ,
},
]
};
